'use client';

import dynamic from 'next/dynamic';

// Templates are loaded on demand so a page only ships the JS and CSS of the template it renders.
// The dynamic imports must live in a client module, because next/dynamic does not code-split
// client components imported from a server component.

export const BookingConfirmation = dynamic(
  () =>
    import('@/components/templates/booking-confirmation/booking-confirmation'),
);
export const BookingFlowPage = dynamic(
  () => import('@/components/templates/booking-flow/booking-flow'),
);
export const CampaignPage = dynamic(
  () => import('@/components/templates/campaign/campaign'),
);
export const CoTravelersLanding = dynamic(
  () =>
    import('@/components/templates/co-travelers-landing/co-travelers-landing'),
);
export const ContentSearch = dynamic(
  () => import('@/components/templates/content-search/content-search'),
);
export const Country = dynamic(
  () => import('@/components/templates/country/country'),
);
export const Destination = dynamic(
  () => import('@/components/templates/destination/destination'),
);
export const Favorites = dynamic(
  () => import('@/components/templates/favorites/favorites'),
);
export const ForbiddenPage = dynamic(
  () => import('@/components/templates/forbidden/forbidden'),
);
export const Hotel = dynamic(
  () => import('@/components/templates/hotel/hotel'),
);
export const MyTrip = dynamic(
  () => import('@/components/templates/my-trip/my-trip'),
);
export const MyTripGuestLogin = dynamic(
  () =>
    import('@/components/templates/my-trip-guest-login/my-trip-guest-login'),
);
export const MyTripProducts = dynamic(
  () => import('@/components/templates/my-trip-products/my-trip-products'),
);
export const MyTripProductsWebview = dynamic(
  () =>
    import(
      '@/components/templates/my-trip-products-webview/my-trip-products-webview'
    ),
);
export const MyTripWebview = dynamic(
  () => import('@/components/templates/my-trip-webview/my-trip-webview'),
);
export const OnboardingFlowPage = dynamic(
  () => import('@/components/templates/onboarding-flow/onboarding-flow'),
);
export const Page = dynamic(() => import('@/components/templates/page/page'));
export const PredefinedSearchPage = dynamic(
  () => import('@/components/templates/predefined-search/predefined-search'),
);
export const ProfilePage = dynamic(
  () => import('@/components/templates/profile/profile'),
);
export const SearchPage = dynamic(
  () => import('@/components/templates/search/search'),
);
export const SignInSignUpFlowPage = dynamic(
  () =>
    import('@/components/templates/sign-in-sign-up-flow/sign-in-sign-up-flow'),
);
export const TravelPortalCampaignPage = dynamic(
  () =>
    import(
      '@/components/templates/travelportal-campaign/travelportal-campaign'
    ),
);
export const TravelPortalSearchPage = dynamic(
  () =>
    import('@/components/templates/travelportal-search/travelportal-search'),
);
